import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import * as fromWorkflow from './workflow/workflow.reducer';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature('workflow', fromWorkflow.reducer)],
})
export class SharedWorkflowDataAccessModule {}
